/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CableTrayFamilyInformation } from '../../components/add-family-information/cable-tray-family-information/cable-tray-family-information.component';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';

export class CableTrayFamilyInformationDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig): any {
    sysquePopupConfig.component = CableTrayFamilyInformation;
    sysquePopupConfig.width = 1080;
    sysquePopupConfig.height = 815;
    sysquePopupConfig.componentTitle = '';
    sysquePopupConfig.visible = true;
  }
}
